<template>
  <div class="text-center mt-10">
    <strong :class="{ 'other-btns': !btnsVisible, 'text-loginGray': btnsVisible }" @click.prevent="btnsVisible = true">
      Citas pierakstīšanās iespējas
    </strong>
    <div class="login-btns mt-8" :class="{ 'no-opacity': !btnsVisible }">
      <div class="login-btn-cell">
        <v-btn border="md" height="44" rounded="pill" flat variant="outlined" @click.prevent="authFacebook">
          <img :src="'/v2/images/login-logos/facebook-logo.png'" alt="Facebook logo" class="mr-1" />
          Facebook
        </v-btn>
      </div>
      <!--
        <div class="login-btn-cell">
          <v-btn border="md" height="44" rounded="pill" flat variant="outlined" @click.prevent="authDraugiem">
            <img :src="'/v2/images/login-logos/draugiem-logo.png'" alt="Draugiem logo" class="mr-1" />
            Draugiem
          </v-btn>
        </div>
        -->
    </div>
  </div>
</template>

<script>
export default {
  setup() {},
  data() {
    return {
      btnsVisible: false,
    }
  },
  computed: {
    oauth() {
      return useRuntimeConfig().public.oauth
    },
  },

  methods: {
    authFacebook() {
      const { facebook } = this.oauth
      const params = new URLSearchParams({
        client_id: facebook.appId,
        redirect_uri: facebook.callbackUrl,
        scope: facebook.scope,
      })
      window.location = `${facebook.authUrl}?${params.toString()}`
    },

    authDraugiem() {
      const { draugiem } = this.oauth
      const params = new URLSearchParams({
        app: draugiem.appId,
        redirect: draugiem.callbackUrl,
        hash: draugiem.hash,
      })

      window.location = `${draugiem.authUrl}?${params.toString()}`
    },
  },
}
</script>

<style scoped lang="sass">
.other-btns
  cursor: pointer
.no-opacity
  opacity: 0
.login-btns
  display: flex
  flex-wrap: wrap
  align-self: center
  justify-content: center

.login-btn-cell
  padding: 4px
  > *
    font-weight: bold
    width: 156px
</style>
